(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gyroor-trusted-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gyroor-trusted-reviews')) {
    customElements.define('gyroor-trusted-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.listeners) return;
        this.listeners = new AbortController();
        const { signal } = this.listeners;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        const dialog = this.querySelector('dialog');
        const reviewDialog = this.querySelector('[data-review-dialog]');
        const reviewDetail = reviewDialog.querySelector('[data-review-detail]');
        const player = this.querySelector('[data-player]');
        const sourceLink = dialog.querySelector('[data-source]');
        const invalid = dialog.querySelector('[data-invalid]');
        const socialEmbed = (value) => {
          let url;
          try { url = new URL(value); } catch { return null; }
          if (url.protocol !== 'https:') return null;
          if (['www.instagram.com', 'instagram.com'].includes(url.hostname)) {
            const reel = url.pathname.match(/^\/(reels?|p)\/([\w-]+)\/?$/);
            if (reel) {
              const path = (reel[1] === 'p' ? 'p/' : 'reel/') + reel[2] + '/';
              const source = 'https://www.instagram.com/' + path;
              return { name: 'Instagram', source, embed: source + 'embed/' };
            }
          }
          if (['www.tiktok.com', 'tiktok.com'].includes(url.hostname)) {
            const video = url.pathname.match(/^\/@([\w.-]+)\/video\/(\d+)\/?$/);
            if (video) return { name: 'TikTok', source: 'https://www.tiktok.com/@' + video[1] + '/video/' + video[2], embed: 'https://www.tiktok.com/player/v1/' + video[2] + '?rel=0' };
          }
          return null;
        };
        let opener;
        const update = (panel) => {
          const track = panel.querySelector('[data-track]');
          if (!track || panel.hidden) return;
          const cards = [...track.children];
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          const positions = [...new Set(cards.map(card => Math.min(max, Math.round(card.offsetLeft))))];
          if (positions[0] !== 0) positions.unshift(0);
          const current = positions.reduce((closest, x, index) => Math.abs(x - track.scrollLeft) < Math.abs(positions[closest] - track.scrollLeft) ? index : closest, 0);
          panel.querySelector('[data-step="-1"]').disabled = track.scrollLeft <= 2;
          panel.querySelector('[data-step="1"]').disabled = track.scrollLeft >= max - 2;
          const dots = panel.querySelector('[data-dots]');
          if (dots) {
            if (dots.children.length !== (positions.length > 1 ? positions.length : 0)) {
              dots.replaceChildren();
              if (positions.length > 1) positions.forEach((_, index) => {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.dataset.position = index;
                dot.setAttribute('aria-label', 'Go to review position ' + (index + 1));
                dots.append(dot);
              });
            }
            [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', index === current ? 'true' : 'false'));
          }
          return { track, positions, current };
        };
        this.observer = new ResizeObserver(() => panels.forEach(update));
        panels.forEach(panel => this.observer.observe(panel));
        const select = (index, focus = false) => {
          const panel = panels[index];
          const pending = panel.querySelector('template[data-customer]');
          if (pending) pending.replaceWith(pending.content.cloneNode(true));
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
          update(panel);
        };
        this.addEventListener('scroll', event => {
          const panel = event.target.closest?.('[role="tabpanel"]');
          if (event.target.matches?.('[data-track]') && panel) update(panel);
        }, { signal, capture: true });
        this.addEventListener('keydown', event => {
          const index = tabs.indexOf(event.target);
          if (index < 0) return;
          const targets = { ArrowLeft: (index + tabs.length - 1) % tabs.length, ArrowRight: (index + 1) % tabs.length, Home: 0, End: tabs.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          select(targets[event.key], true);
        }, { signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          const index = tabs.indexOf(button);
          if (index >= 0) return select(index);
          if (button.hasAttribute('data-close')) return button.closest('dialog').close();
          if (button.hasAttribute('data-open-review')) {
            const content = button.closest('.gtr__review').querySelector('[data-full-review]');
            opener = button;
            reviewDetail.replaceChildren(content.content.cloneNode(true));
            reviewDialog.showModal();
            return;
          }
          const isSocial = button.hasAttribute('data-social-video');
          if (isSocial || (button.dataset.video && /^[A-Za-z0-9_-]{11}$/.test(button.dataset.video))) {
            opener = button;
            dialog.classList.toggle('gtr__dialog--social', isSocial);
            const social = isSocial ? socialEmbed(button.dataset.socialVideo) : null;
            invalid.hidden = !isSocial || Boolean(social);
            sourceLink.hidden = !social;
            if (social) {
              sourceLink.href = social.source;
              sourceLink.textContent = 'Watch on ' + social.name;
            }
            if (isSocial && !social) {
              dialog.showModal();
              return;
            }
            const frame = document.createElement('iframe');
            frame.title = social ? social.name + ' video' : 'Expert review video';
            frame.src = social ? social.embed : 'https://www.youtube-nocookie.com/embed/' + button.dataset.video + '?autoplay=1&rel=0';
            frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            frame.allowFullscreen = true;
            player.replaceChildren(frame);
            dialog.showModal();
            return;
          }
          const panel = button.closest('[role="tabpanel"]');
          if (!panel) return;
          const state = update(panel);
          if (!state) return;
          const target = button.dataset.position ?? (state.current + Number(button.dataset.step));
          const left = state.positions[target];
          if (left !== undefined) state.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        dialog.addEventListener('click', event => {
          if (event.target === dialog) {
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }
        }, { signal });
        dialog.addEventListener('close', () => {
          player.replaceChildren();
          opener?.focus();
        }, { signal });
        reviewDialog.addEventListener('close', () => {
          reviewDetail.replaceChildren();
          opener?.focus();
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[role="tabpanel"]');
          if (!panel) return;
          select(panels.indexOf(panel));
          event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, { signal });
        this.querySelectorAll("[data-youtube-cover]").forEach(image => {
          const hideMissingCover = () => { image.hidden = true; };
          image.addEventListener("error", hideMissingCover, { signal, once: true });
          if (image.complete && image.naturalWidth === 0) hideMissingCover();
        });
        select(Math.max(0, tabs.findIndex(tab => tab.getAttribute("aria-selected") === "true")));
      }

      disconnectedCallback() {
        this.listeners?.abort();
        this.listeners = null;
        this.observer?.disconnect();
        this.querySelector('[data-player]')?.replaceChildren();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
